<template>
  <div
    class="w-full bg-[url('https://images.rafflebox.ca/RaffleboxLogos/WebsiteAssets/why-run-section-bg.svg')] bg-cover bg-[position:-80px_0px] px-10 py-24 mt-24 md:mt-0 text-center md:bg-[position:0px_0px]"
  >
    <div class="mx-auto max-w-[90rem]">
      <h1 class="mt-20 mb-2 text-center text-4xl lg:mt-0 lg:text-6xl">{{ t('HomeWhyRafflebox.title') }}</h1>

      <div
        class="mt-6 grid grid-cols-1 justify-items-center gap-6 md:mt-12 md:grid-cols-2 md:gap-8 lg:grid-cols-4 lg:grid-rows-1 lg:gap-8"
      >
        <div class="bg-rbgreen-450 mt-6 rounded-3xl p-6 text-left text-white md:mt-0">
          <i class="pi pi-share-alt text-3xl" />
          <h4 class="mt-4 mb-5 text-3xl">{{ t('HomeWhyRafflebox.card1.title') }}</h4>
          <p class="mb-4 text-lg -tracking-[.4px]">
            {{ t('HomeWhyRafflebox.card1.description') }}
          </p>
        </div>
        <div class="rounded-3xl bg-yellow-500 p-6 text-left text-black">
          <i class="pi pi-sync text-3xl" />
          <h4 class="mt-4 mb-5 text-3xl">{{ t('HomeWhyRafflebox.card2.title') }}</h4>
          <p class="mb-4 text-lg -tracking-[.4px]">
            {{ t('HomeWhyRafflebox.card2.description') }}
          </p>
        </div>
        <div class="rounded-3xl bg-indigo-500 p-6 text-left text-white">
          <i class="pi pi-question-circle text-3xl" />
          <h4 class="mt-4 mb-5 text-3xl">{{ t('HomeWhyRafflebox.card3.title') }}</h4>
          <p class="mb-4 text-lg -tracking-[.4px]">
            {{ t('HomeWhyRafflebox.card3.description') }}
          </p>
        </div>
        <div class="rounded-3xl bg-neutral-50 p-6 text-left text-neutral-900">
          <i class="pi pi-chart-line text-3xl" />
          <h4 class="mt-4 mb-5 text-3xl">{{ t('HomeWhyRafflebox.card4.title') }}</h4>
          <p class="mb-4 text-lg -tracking-[.4px]">
            {{ t('HomeWhyRafflebox.card4.description') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();

defineOptions({
  name: 'WhyRunARaffleboxSection',
});
</script>
